import type {
  AttachInvoiceUserFilesResponse,
  AttachInvoiceUserFilesVariables,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodAttachInvoiceUserFilesPayloadSchema,
  zodAttachInvoiceUserFilesResponseSchema,
} from './validations';

/**
 * Attaches staged Filehub uploads to an invoice in one batch.
 *
 * @param variables - Invoice identifier and staged files with their roles.
 * @returns Per-file attachment outcomes and the updated invoice.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/attach_user_file_invoices__invoice_id__user_files_post
 */
export async function attachInvoiceUserFiles({
  invoiceId,
  payload,
}: AttachInvoiceUserFilesVariables): Promise<AttachInvoiceUserFilesResponse> {
  return vestigasApi
    .post(ENDPOINT.INVOICE.ATTACH_USER_FILES(invoiceId), {
      json: payload,
      validate: {
        body: zodAttachInvoiceUserFilesPayloadSchema,
        isResponseSensitive: true,
        response: zodAttachInvoiceUserFilesResponseSchema,
      },
    })
    .json<AttachInvoiceUserFilesResponse>();
}
